// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 07-12-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH GOLD LOAN ARREAR REPORT DETAILS START *********************** */
export const goldLoanArrearReportFetch = (fetchData: any) => {
	const data = {
		FetchGoldLoanArrearTokens: fetchData,
	};
	const url = `${API_URL}FetchGoldLoanArrearDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GOLD LOAN ARREAR REPORT DETAILS END *********************** */
